module.exports = __webpack_public_path__ + "static/media/fly.fbb9d1da.png";